var _path, _rect, _path2, _path3, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThirdCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 168,
    viewBox: "0 0 304 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250 123.354L304 92.1769L250 61V77.0001H0V107H250V123.354Z",
    fill: "#33CC66"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85.4478,
    height: 124.288,
    rx: 5,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 115 42.856)",
    fill: "#E2F8EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 47.856C115 45.0945 116.939 41.7367 119.33 40.356L184.67 2.63204C187.061 1.25133 189 2.37061 189 5.13204L189 93.3479L115 136.072L115 47.856Z",
    fill: "#F5FDF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.941 52.5624L166.941 44.1706L166.514 44.417L166.514 52.8089L163.383 54.6164L158.616 62.7749L158.616 46.6367L155.557 48.403L155.557 35.6538L155.13 35.9003L155.13 48.6495L151.999 50.457L151.999 66.5952L147.232 63.9411L144.102 65.7485L144.102 57.3567L143.675 57.6031L143.675 65.995L140.615 67.7614L140.615 89.4673L143.675 87.7009L143.675 99.4818L144.102 99.2354L144.102 87.4545L147.232 85.647L147.232 72.8978L151.999 75.5519L151.999 89.2694L155.13 87.4619L155.13 103.762L155.557 103.515L155.557 87.2155L158.616 85.4491L158.616 71.7316L163.383 63.5731L163.383 76.3223L166.514 74.5148L166.514 86.2957L166.941 86.0492L166.941 74.2683L170 72.502L170 50.7961L166.941 52.5624Z",
    fill: "#33CC66"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 31.0719,
    height: 12,
    rx: 1,
    transform: "matrix(0.866025 -0.5 -2.20305e-08 -1 121.727 154.715)",
    fill: "#04C35C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 31.0719,
    height: 7.76799,
    rx: 1,
    transform: "matrix(0.866025 -0.5 -2.20305e-08 -1 155.364 135.295)",
    fill: "#04C35C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdCardIcon);
export default __webpack_public_path__ + "static/media/ThirdCardIcon.ce2ee80bc3ed33e530e8a37b8cfdac68.svg";
export { ForwardRef as ReactComponent };